import { AgGridReact } from 'ag-grid-react'

import React from 'react'
import { useAlert } from 'react-alert'
import { AnnouoncementsModal, Error, Header, Loader } from '../components'
import { useStateContext } from '../contexts/ContextProvider'
import { useAddAnnouncementMutation, useDeleteAnnouncementMutation, useGetAnnouncementsQuery } from '../redux/announcements/announcementApi'

import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css'

//icons 
import { BiTrash } from 'react-icons/bi'

const CellRenderer = p => {
  return <div className='flex flex-row'>
    <div>
      <BiTrash className='mt-1 text-red-600 hover:cursor-pointer' onClick={() => {
        p.func(p.data._id)
      }} />

    </div>
    <p className='pl-2'>{p.value}</p>
  </div>
}

const Announcements = () => {

  const { data, isLoading, error } = useGetAnnouncementsQuery()
  const [deleteAnnouncement] = useDeleteAnnouncementMutation()
  const [addAnnouncement] = useAddAnnouncementMutation()
  const { currentMode } = useStateContext()

  const alert = useAlert()

  if (isLoading) return <Loader />

  if (error) {
    alert.error(alert.data.message)
    alert.removeAll()
    return <Error />
  }


  const defaultColDefs = {
    sortable: true, filter: true,
  }

  const columnsDefs = [

    {
      field: 'title', headerName: "Announcement Title", flex: 2, cellRenderer: CellRenderer, cellRendererParams: {
        func: deleteAnnouncement
      }
    },
    { field: 'description', flex: 4 },


  ]




  return (<div className={`m-2 md:m-10 p-2 md:p-10 bg-white rounded-3xl ${currentMode === 'Dark' ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'} h-[500px]`}>
    <Header title="Make Announcements 🗣🗣" category="Page" />

    <div className='h-[70%] w-[100%] ' style={{
    }}>
      <AgGridReact rowData={data.announcements} columnDefs={columnsDefs} defaultColDef={defaultColDefs} animateRows={true} />
    </div>
    <div className='float-right mt-2'>

      <AnnouoncementsModal addAnnouncement={addAnnouncement} />
    </div>
  </div>
  )
}

export default Announcements

